export class SeatOrder {
  constructor(name, rounds) {
    this.name = name;
    this.rounds = rounds;
  }
}
